export const tokenAbi = [
	{
		"inputs": [
			{
				"internalType": "address payable",
				"name": "_controlCenter",
				"type": "address"
			},
			{
				"internalType": "string",
				"name": "_name",
				"type": "string"
			},
			{
				"internalType": "string",
				"name": "_symbol",
				"type": "string"
			},
			{
				"internalType": "address",
				"name": "_trustedForwarder",
				"type": "address"
			},
			{
				"internalType": "string",
				"name": "_uri",
				"type": "string"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "Paused",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "bool",
				"name": "transferable",
				"type": "bool"
			}
		],
		"name": "RestrictedTransferUpdated",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "previousAdminRole",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "newAdminRole",
				"type": "bytes32"
			}
		],
		"name": "RoleAdminChanged",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "sender",
				"type": "address"
			}
		],
		"name": "RoleGranted",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "sender",
				"type": "address"
			}
		],
		"name": "RoleRevoked",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "Unpaused",
		"type": "event"
	},
	{
		"inputs": [],
		"name": "DEFAULT_ADMIN_ROLE",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "DOMAIN_SEPARATOR",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "MINTER_ROLE",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "PAUSER_ROLE",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "TRANSFER_ROLE",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "_contractURI",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			}
		],
		"name": "allowance",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "approve",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "balanceOf",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "burn",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "burnFrom",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "contractURI",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "decimals",
		"outputs": [
			{
				"internalType": "uint8",
				"name": "",
				"type": "uint8"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "subtractedValue",
				"type": "uint256"
			}
		],
		"name": "decreaseAllowance",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			}
		],
		"name": "getRoleAdmin",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "",
				"type": "bytes32"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
		],
		"name": "getRoleMember",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			}
		],
		"name": "getRoleMemberCount",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "grantRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "hasRole",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "addedValue",
				"type": "uint256"
			}
		],
		"name": "increaseAllowance",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "forwarder",
				"type": "address"
			}
		],
		"name": "isTrustedForwarder",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "mint",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes[]",
				"name": "data",
				"type": "bytes[]"
			}
		],
		"name": "multicall",
		"outputs": [
			{
				"internalType": "bytes[]",
				"name": "results",
				"type": "bytes[]"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "name",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "nonces",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "pause",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "paused",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "deadline",
				"type": "uint256"
			},
			{
				"internalType": "uint8",
				"name": "v",
				"type": "uint8"
			},
			{
				"internalType": "bytes32",
				"name": "r",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "s",
				"type": "bytes32"
			}
		],
		"name": "permit",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "renounceRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "role",
				"type": "bytes32"
			},
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "revokeRole",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "string",
				"name": "_URI",
				"type": "string"
			}
		],
		"name": "setContractURI",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bool",
				"name": "_restrictedTransfer",
				"type": "bool"
			}
		],
		"name": "setRestrictedTransfer",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes4",
				"name": "interfaceId",
				"type": "bytes4"
			}
		],
		"name": "supportsInterface",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "symbol",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "recipient",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "transfer",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "recipient",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "transferFrom",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "transfersRestricted",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "unpause",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
]
export const tokenBytecode = "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"